import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/style/base.less'
import VueClipboard from 'vue-clipboard2'
import 'amfe-flexible/index.js'
import {
  Toast,
  Overlay,
  Button,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Form,
  Field
} from 'vant'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(Toast)
Vue.use(Overlay)
Vue.use(Button)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Form)
Vue.use(Field)
// new VConsole()
Vue.config.productionTip = false
// 拦截器
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'yidianlife'
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
